// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SZDmZ","column":"styles_column__ram6o","title":"styles_title__S8YDN","file":"styles_file__RgFvR"};